import { CheckCircle2, CircleDashed, CircleDot, Loader, OctagonAlert, SquareSplitHorizontal } from 'lucide-react'
import type { ReactNode } from 'react'

import type { StatusBadgeVm } from '../model/viewModels'

/** Статус поставки: слово + значок + вид рамки, а не цвет (grayscale читаем). */
const ICONS: Record<StatusBadgeVm['tone'], ReactNode> = {
  draft: <CircleDashed size={14} aria-hidden="true" />,
  ready: <CircleDot size={14} aria-hidden="true" />,
  progress: <Loader size={14} aria-hidden="true" />,
  done: <CheckCircle2 size={14} aria-hidden="true" />,
  partial: <SquareSplitHorizontal size={14} aria-hidden="true" />,
  failed: <OctagonAlert size={14} aria-hidden="true" />,
}

export function StatusBadge({ badge }: { badge: StatusBadgeVm }) {
  return (
    <span className="onec-badge" data-tone={badge.tone}>
      {ICONS[badge.tone]}
      {badge.label}
    </span>
  )
}
